/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Upload_ImageInputs */

const fr_changelog_upload_image = /** @type {(inputs: Changelog_Upload_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger une image`)
};

/**

* @param {Changelog_Upload_ImageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_upload_image = /** @type {((inputs?: Changelog_Upload_ImageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Upload_ImageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_upload_image(inputs)
});